/*
 * @Author: 317473294@qq.com
 * @Date: 2023-09-14 15:28:26
 * @LastEditTime: 2023-09-17 13:48:06
 * @LastEditors: 317473294@qq.com
 * @Description: 
 * @FilePath: /english_admin_v1.1.0/src/components/common/message.js
 */
import Vue from 'vue'
import { MessageBox, Message } from "element-ui";
Vue.component(Message.name, Message)
Vue.component(MessageBox.name, MessageBox)


export const zdyMessage = {
    //注意不要使用vue.use 不然初次加载会自动调用一次函数
    /*** @hand this.$handAlent()* @author 封装 element-ui 消息提示* @param text* @param type * @returns {Promise}
    */
    handMessage: (text = '操作成功', type = "success") => {
        return Message({ showClose: true, message: text, type: type })
    },
    /** * @hand this.$handClose()* @author 封装 element-ui 确定取消提示框* @param text* @param res 确定操作函数* @param rej 取消操作函数* @returns {Promise}* 
    */
    deleteTipMessage: (text = '是否执行此操作', res, rej) => {
        const body="你确定要删除【"+text+"】吗？"
        MessageBox.confirm(body, '提醒', { confirmButtonText: '确定', cancelButtonText: '取消',type:'warning' }).then(() => { res() }).catch(() => { rej() });
    },
    //定制为课程目录管理
    deleteTipCourseMessage: (text = '是否执行此操作', res, rej) => {
        const body="你确定要删除【"+text+"】吗？删除该目录需要先去删除对应课程知识点的所有内容。"
        MessageBox.confirm(body, '提醒', { confirmButtonText: '确定', cancelButtonText: '取消',type:'warning' }).then(() => { res() }).catch(() => { rej() });
    }

}



// WEBPACK FOOTER //
// ./src/components/common/message.js